"use client";
const t = Object.freeze({
  landscape: "aspect-ratio >= 1/1",
  portrait: "aspect-ratio <= 1/1",
  widescreen: "width >= 1600px",
  desktop: "width >= 1200px",
  desktopMax: "width <= 1599px",
  tablet: "width >= 768px",
  tabletMax: "width <= 1199px",
  mobile: "width >= 540px",
  mobileMax: "width <= 767px"
});
export {
  t as MEDIA_QUERIES
};
